export default {
  PlaneType__CHANGE_DISCLAIMER: `(subject to change)*`,
  PlaneType__INFORMATION_ARIA_LABEL: (data) => `Plane Type ${data.PLANE_TYPE}`,
};
